// AuthContext.js
import React, {
    createContext,
    useState,
    useEffect
} from "react";
import axios from "axios";
import {
    jwtDecode
} from "jwt-decode";


export const AuthContext = createContext();

export const AuthProvider = ({
    children
}) => {
    const [user, setUser] = useState(() => {
        try {
            const cachedUser = localStorage.getItem("user");
            return cachedUser ? JSON.parse(cachedUser) : null;
        } catch {
            return null;
        }
    });

    const login = (userData, token) => {
        setUser(userData);
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(userData));
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        delete axios.defaults.headers.common["Authorization"];
        window.location.href = "/login"; // redirect to login
    };

    // Check token on app load
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                if (decoded.exp * 1000 < Date.now()) {
                    // Token expired
                    logout();
                } else {
                    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
                    const rehydratedUser = {
                        id: decoded.id || decoded.userId || decoded.Id,
                        email: decoded.email,
                        name: decoded.name || decoded.fullName,
                        role: decoded.role || decoded.userType,
                        contactNo: decoded.contactNo,
                    };
                    setUser((prev = {}) => {
                        const merged = {
                            ...prev
                        };
                        Object.entries(rehydratedUser).forEach(([key, value]) => {
                            if (value !== undefined && value !== null && value !== "") {
                                merged[key] = value;
                            }
                        });
                        return merged;
                    }); // adjust to your payload
                }
            } catch (err) {
                logout(); // invalid token
            }
        }
    }, []);

    useEffect(() => {
        if (user) {
            localStorage.setItem("user", JSON.stringify(user));
        } else {
            localStorage.removeItem("user");
        }
    }, [user]);

    return ( <
        AuthContext.Provider value = {
            {
                user,
                login,
                logout,
            }
        } >
        {
            children
        } <
        /AuthContext.Provider>
    );
};